/// <reference types="node" />
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

//platformBrowserDynamic().bootstrapModule(AppModule).catch(err => console.error(err));
// Function to wait for configuration
function waitForConfig(): Promise<void> {
  //console.log('config check fired');
  return new Promise((resolve) => {
    const checkConfig = () => {
      if (window['pghconfig']?.okta) {
        //console.log('Config loaded');
        resolve();
      } else {
        //console.log('Waiting to load config');
        setTimeout(checkConfig, 100); // Check every 100ms

      }
    };
    checkConfig();
  });
}

// Bootstrap the Angular application once the configuration is available
waitForConfig().then(() => {
    //console.log('load app');
    platformBrowserDynamic().bootstrapModule(AppModule).catch(err => console.error(err));
});
